module.exports = __webpack_public_path__ + "img/Unidad16-3.86fd0fac.png";